import { useSelector } from 'react-redux'
import { StateExtended } from '../../_config/interfaces/stateExtended'


export function useStatesSelector() {
  const states = useSelector((state: StateExtended) => state.master.states);
  return states
}

export function useAllCountySelector() {
  const county = useSelector((state: StateExtended) => state.master.allCounty);
  return county
}

export function useAllCitySelector() {
  const city = useSelector((state: StateExtended) => state.master.allCity)
  return city
}

export function useFacilityManagersSelector() {
  const managers = useSelector((state: StateExtended) => state.master.facilityManagers)
  return managers
}

export function useServiceTechsSelector() {
  const serviceTechs = useSelector((state: StateExtended) => state.master.serviceTechs);
  return serviceTechs
}

export function useTeamsSelector() {
  const teams = useSelector((state: StateExtended) => state.master.teams)
  return teams
}

export function useElectricityProvidersSelector() {
  const electricityProviders = useSelector((state: StateExtended) => state.master.electricityProviders)
  return electricityProviders
}

export function useGasProvidersSelector() {
  const gasProviders = useSelector((state: StateExtended) => state.master.gasProviders)
  return gasProviders
}

export function useWaterProvidersSelector() {
  const waterProviders = useSelector((state: StateExtended) => state.master.waterProviders)
  return waterProviders
}

export function useTelephoneProvidersSelector() {
  const telephoneProviders = useSelector((state: StateExtended) => state.master.telephoneProviders)
  return telephoneProviders
}

export function useAssestCategoriesSelector() {
  const data = useSelector((state: StateExtended) => state.master.assetsCategories)
  return data
}

export function useAssestDepartmentsSelector() {
  const data = useSelector((state: StateExtended) => state.master.assetsDepartments)
  return data
}

export function useAssestGroupsSelector() {
  const data = useSelector((state: StateExtended) => state.master.assetsGroups)
  return data
}

export function useAssestSubGroupsSelector() {
  const data = useSelector((state: StateExtended) => state.master.assetsSubGroups)
  return data
}

export function useAssestTypesSelector() {
  const data = useSelector((state: StateExtended) => state.master.assetsTypes)
  return data
}

export function useAssestClassificationsSelector() {
  const data = useSelector((state: StateExtended) => state.master.assetsClassifications)
  return data
}

export function useAssestStatuesSelector() {
  const data = useSelector((state: StateExtended) => state.master.assetsStatues)
  return data
}